import http from '../http'

/**
 * 创建前预览（结算单及利息列表）
 */
export function previewInterestCalculation(params) {
  return http.get('/interest-calculations/preview', { params })
}

/**
 * 创建利息计算
 * needSupplierAudit 由调用方显式传递（默认 false），确保后台正确判断初始状态
 */
export function createInterestCalculation(data) {
  const requestData = {
    contractId: data.contractId,
    cutoffDate: data.cutoffDate,
    needSupplierAudit: data.needSupplierAudit === true
  }
  if (data.projectId !== undefined && data.projectId !== null) {
    requestData.projectId = data.projectId
  }
  if (data.needSupplierAudit && data.supplierAuditorId != null) {
    requestData.supplierAuditorId = data.supplierAuditorId
  }
  return http.post('/interest-calculations', requestData)
}

/**
 * 更新利息计算
 */
export function updateInterestCalculation(id, data) {
  return http.put(`/interest-calculations/${id}`, data)
}

/**
 * 获取利息计算详情
 */
export function getInterestCalculationById(id) {
  return http.get(`/interest-calculations/${id}`)
}

/**
 * 分页查询利息计算列表
 */
export function queryInterestCalculations(params) {
  return http.get('/interest-calculations', { params })
}

/**
 * 获取结算单汇总列表
 */
export function getInterestCalculationSettlements(id, params = {}) {
  return http.get(`/interest-calculations/${id}/settlements`, { params })
}

/**
 * 获取付款流水明细
 */
export function getInterestCalculationFlows(id, settlementId) {
  return http.get(`/interest-calculations/${id}/settlements/${settlementId}/flows`)
}

/**
 * 需求方确认
 */
export function demandConfirmInterestCalculation(id, data = {}) {
  return http.put(`/interest-calculations/${id}/demand-confirm`, data)
}

/**
 * 供应商审核通过
 */
export function supplierAuditInterestCalculation(id) {
  return http.put(`/interest-calculations/${id}/supplier-audit`)
}

/**
 * 需求方审核通过
 */
export function demandAuditInterestCalculation(id) {
  return http.put(`/interest-calculations/${id}/demand-audit`)
}

/**
 * 回退状态
 */
export function rollbackInterestCalculation(id) {
  return http.put(`/interest-calculations/${id}/rollback`)
}

/**
 * 删除利息计算
 */
export function deleteInterestCalculation(id) {
  return http.delete(`/interest-calculations/${id}`)
}
